module.exports = __webpack_public_path__ + "img/cal-male-condom.38d5cbed.png";